import { useRef, useState, ReactNode } from 'react';
import { createPortal } from 'react-dom';

interface TooltipProps {
    content: ReactNode;
    children: ReactNode;
}

export function Tooltip({ content, children }: TooltipProps) {
    const [coords, setCoords] = useState<{ top: number; left: number } | null>(null);
    const anchorRef = useRef<HTMLDivElement>(null);

    const show = () => {
        const rect = anchorRef.current?.getBoundingClientRect();
        if (rect) {
            setCoords({ top: rect.top, left: rect.left + rect.width / 2 });
        }
    };
    const hide = () => setCoords(null);

    return (
        <>
            <div ref={anchorRef} onMouseEnter={show} onMouseLeave={hide}>
                {children}
            </div>
            {coords &&
                createPortal(
                    <div
                        className="fixed z-[100] -translate-x-1/2 -translate-y-full pointer-events-none animate-fadeIn"
                        style={{ top: coords.top - 8, left: coords.left }}
                    >
                        <div className="rounded-lg border border-[var(--color-border)] bg-[var(--color-bg-card)] shadow-lg px-3 py-2 text-xs max-w-[240px] whitespace-normal">
                            {content}
                        </div>
                    </div>,
                    document.body
                )}
        </>
    );
}
